import services from 'services';

export function useServices() {
  return services;
}
